// Internal Config
// Client Config when Remote Config is disabled
export function adaptAampClientConfig(config) {
    return config;
}
// Server Config when Remote Config is enabled
// Client Config when Remote Config is enabled
export function adaptAampRemoteConfigSplit(config) {
    var _config_clientConfig = config.clientConfig, clientConfig = _config_clientConfig === void 0 ? {} : _config_clientConfig, _config_remoteConfig = config.remoteConfig, remoteConfig = _config_remoteConfig === void 0 ? {} : _config_remoteConfig;
    return {
        manifestTimeoutInSeconds: remoteConfig.manifestTimeoutInSeconds,
        preCachePlaylistTimeInMinutes: remoteConfig.preCachePlaylistTimeInMinutes,
        shouldUseSurround: remoteConfig.shouldUseSurround,
        shouldUseAverageBandwidth: remoteConfig.shouldUseAverageBandwidth,
        resumeInAdBreakOffsetInSeconds: remoteConfig.resumeInAdBreakOffsetInSeconds,
        downloadStallTimeoutInSeconds: remoteConfig.downloadStallTimeoutInSeconds,
        downloadStartTimeoutInSeconds: remoteConfig.downloadStartTimeoutInSeconds,
        minimumSafeBitrate: remoteConfig.minimumSafeBitrate,
        shouldUseNewAbr: remoteConfig.shouldUseNewAbr,
        enableInternalRetryFunctionality: remoteConfig.enableInternalRetryFunctionality,
        useRetuneForUnpairedDiscontinuity: remoteConfig.useRetuneForUnpairedDiscontinuity,
        playlistTimeout: remoteConfig.playlistTimeout,
        vodNetworkTimeout: remoteConfig.vodNetworkTimeout,
        linearNetworkTimeout: remoteConfig.linearNetworkTimeout,
        missingProgressUpdateLimit: remoteConfig.missingProgressUpdateLimit,
        initFragmentRetryCount: remoteConfig.initFragmentRetryCount,
        enableSeekableRange: remoteConfig.enableSeekableRange,
        enableLiveLatencyCorrection: remoteConfig.enableLiveLatencyCorrection,
        enableAsyncTune: remoteConfig.enableAsyncTune,
        progressReportingInterval: clientConfig.progressReportingInterval,
        enablePTSReStamp: clientConfig.enablePTSReStamp
    };
}

//# sourceMappingURL=aamp-config-adapter.js.map